module.exports = __webpack_public_path__ + "static/media/img_featuredissues-sextingonline_grooming.c1b1ded2.png";